import { getter } from "@progress/kendo-react-common";
import { GridPagerSettings } from "@progress/kendo-react-grid";

export const DATA_ITEM_KEY = "Id";
export const EDIT_FIELD = "inEdit";
export const SELECTED_FIELD = "selected";
export const DELETABLE_FIELD = "isDeletable";

export const idGetter = getter(DATA_ITEM_KEY);

export const gridPagerDefaultSettings: GridPagerSettings = {
  pageSizes: [25, 50, 75, 100],
  buttonCount: 5,
};

export const roundToTwoDecimals = "{0:n2}";
